import { Component, Output, Input, EventEmitter, OnInit, OnDestroy } from '@angular/core';
import { FormBase } from '@core/_classes/form.base';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import { MessagesService } from '@core/_services/messages.service';
import { AuthService } from '@auth/auth.service';
import { AutofocusDirective } from '@directives/auto-focus.directive';
import { Message } from 'primeng/api';
import {TranslateModule, TranslateService} from '@ngx-translate/core';
import {DropdownModule} from "primeng/dropdown";
import {InputSwitchModule} from "primeng/inputswitch";
import {InputTextareaModule} from "primeng/inputtextarea";
import {ListboxModule} from "primeng/listbox";

@Component({
    selector: 'app-form-admindelegate',
    standalone: true,
    templateUrl: './form-admindelegate.component.html',
    styleUrls: ['./form-admindelegate.component.scss'],
    providers: [AutofocusDirective],
    imports: [
        ReactiveFormsModule,
        DropdownModule,
        TranslateModule,
        InputSwitchModule,
        InputTextareaModule,
        ListboxModule
    ]
})
export class FormAdminDelegateComponent extends FormBase implements OnInit, OnDestroy {
    public resultForm: FormGroup;
    public validClick = false;
    public isAdmin = false;

    @Input()
    public result: any = null;

    @Input()
    public delegateBase = [];

    @Input()
    public delegateList = [];

    @Output()
    public onValidate: EventEmitter<any> = new EventEmitter();

    @Output()
    public onCancel: EventEmitter<any> = new EventEmitter();

    @Output()
    public onDelete: EventEmitter<any> = new EventEmitter();

    constructor(
        private formBuilder: FormBuilder,
        private auth: AuthService,
        protected messageService: MessagesService,
        private translate: TranslateService
    ) {
        // Injection de messageService dans la classe mère
        super(messageService);

        this.isAdmin = this.auth.isAdmin();
        this.resultForm = this.formBuilder.group({
            id: null,
            name: [{value: null, disabled: false}, [Validators.required]],
            desc: null,
            mgtUser: false,
            mgtGrp: false,
            mgtBsk: false,
            mgtGed: false,
            mgtDlgt: false
        });
        this.initialization();
    }


    ngOnInit() {
        if (this.result !== null) {    
            this.result.notifyParent.subscribe(success => {
                if (this.result) {
                    this.resultForm.controls['name'].disable();
                    this.resultForm.patchValue(this.result);
                    const wRightValues = JSON.parse(this.result.rightValues);
                    this.resultForm.controls['mgtBsk'].setValue(wRightValues.mgtBsk);
                    this.resultForm.controls['mgtDlgt'].setValue(wRightValues.mgtDlgt);
                    this.resultForm.controls['mgtGed'].setValue(wRightValues.mgtGed);
                    this.resultForm.controls['mgtGrp'].setValue(wRightValues.mgtGrp);
                    this.resultForm.controls['mgtUser'].setValue(wRightValues.mgtUser);
                }
            })
        }
    }

    ngOnDestroy() {
        if (this.result !== null) {            
            this.result.notifyParent.unsubscribe()
        }
    }

    public validate() {
        let wRequest: any;
        wRequest = new Object();
        wRequest = {
            entete: this.resultForm.getRawValue(),
        };
        if (this.verifyRole(wRequest.entete) === false) {
            this.messageService.addErrorMsg(this.translate.instant('Admin_Dlg_NoRole'));
            return;
        }
        this.validClick = true;
        const error: Array<Message> = [];
        if (this.resultForm.invalid) {
            this.getErrorsInputs(error, this.resultForm);
        } else {
            this.onValidate.emit(wRequest);
        }
    }

    private verifyRole(aRequest) {
        if (aRequest.mgtBsk === false && aRequest.mgtGed === false && aRequest.mgtGrp === false && aRequest.mgtUser === false && aRequest.mgtDlgt === false) {
            return false;
        } else {
            return true;
        }
    }

    public cancel() {
        this.validClick = false;
        this.onCancel.emit('cancel');
    }

    public deleteItem() {
        this.onDelete.emit(this.resultForm.getRawValue());
    }

    private initialization() {
        this.keys = {
            name: {
                label: this.translate.instant('User_1'),
                pattern: '',
            }
        };
    }
}
